import fetch from "../auth/FetchInterceptor";

export const getUserRoles = async () => {
  return fetch({ url: "/roles", method: "get" });
};

export const addUserAttribute = async (name) => {
  return fetch({
    url: "/user/attributes",
    method: "put",
    data: { name },
  });
};

export const agreeToTerms = async () => {
  return fetch({
    url: "/user/privacy-policy ",
    method: "put",
    data: {
      has_agreed_to_privacy_policy: true,
    },
  });
};

export const inviteUser = async ({
  email,
  role_id,
  closets,
  personal_message,
}) => {
  return fetch({
    url: `/company/invite-user`,
    method: "post",
    data: { email, role_id, closets, personal_message },
  });
};

export const inviteUserByClosetAdmin = async ({
  email,
  personal_message = null,
}) => {
  return fetch({
    url: `/company/invite-user/by-closet-admin`,
    method: "post",
    data: { email, personal_message },
  });
};

export const acceptUserInvitation = async ({ token }) => {
  return fetch({
    url: "/accept-user-invitation",
    method: "post",
    data: { token },
  });
};

export const getCompanyUsers = async ({ pagination_params, filter_params }) => {
  return fetch({
    url: `/company/users`,
    method: "get",
    params: { ...pagination_params, ...filter_params },
  });
};

export const giveUserBillingResponsibility = async ({ user_id }) => {
  return fetch({
    url: `/company/users/${user_id}/billing-update`,
    method: "put",
  });
};

export const removeCompanyUser = async ({ user_id }) => {
  return fetch({ url: `/company/users/${user_id}`, method: "delete" });
};

export const changeUserRole = async ({ user_id, role_id }) => {
  return fetch({
    url: `/company/users/${user_id}/change-role`,
    method: "put",
    data: { role_id },
  });
};

export const updateUserAccess = async ({ user_id, data }) => {
  return fetch({
    url: `/user/${user_id}/user-access`,
    method: "patch",
    data,
  });
};

export const getUserAccessibleClosets = async ({ userId }) => {
  return fetch({ url: `/user/${userId}/closets`, method: "get" });
};

export const setUserAccessibleClosets = async ({ userId, data }) => {
  return fetch({ url: `/user/${userId}/closets`, method: "put", data });
};

export const getUserClosets = async () => {
  return fetch({ url: `/user/closets`, method: "get" });
};

export const deleteProfilePicture = async () => {
  return fetch({ url: `/user/profile-picture`, method: "delete" });
};

export const updateUser = async (data) => {
  return fetch({ url: `/user`, method: "put", data });
};
export const getUserDepartments = async () => {
  return fetch({ url: `/user/departments`, method: "get" });
};
export const updateUserDepartment = async (data) => {
  return fetch({ url: `/user/department`, method: "patch", data });
};
export const getUserProfileQuestions = async () => {
  return fetch({ url: `/user/profile-questions`, method: "get" });
};
export const updateUserProfileQuestions = async (data) => {
  return fetch({ url: `/user/profile-questions`, method: "patch", data });
};
export const updateUserLocale = async (locale) => {
  return fetch({ url: `/user/locale`, method: "patch", data: { locale } });
};
export const changePassword = async (data) => {
  return fetch({ url: `/user/password`, method: "put", data });
};
export const getUserInvitations = async ({ pagination_params }) => {
  return fetch({
    url: `/user-invitations`,
    method: "get",
    params: { ...pagination_params },
  });
};
export const getUserInvitationDetails = async ({ userInvitationId }) => {
  return fetch({
    url: `/user-invitations/${userInvitationId}`,
    method: "get",
  });
};
export const resendUserInvitation = async ({ userInvitationId }) => {
  return fetch({
    url: `/user-invitations/${userInvitationId}`,
    method: "patch",
  });
};
export const cancelUserInvitation = async (data) => {
  return fetch({ url: `/cancel-user-invitation`, method: "patch", data });
};
export const uploadUserInvitationsList = async (data) => {
  return fetch({ url: "/map-invitations-template-file", method: "post", data });
};
export const inviteMultipleUsers = async (data) => {
  return fetch({ url: "/send-multiple-invitations", method: "post", data });
};
export const uploadUserInvitationsListByClosetAdmin = async (data) => {
  return fetch({ url: "/map-invitations-template-file/by-closet-admin", method: "post", data });
};
export const inviteMultipleUsersByClosetAdmin = async (data) => {
  return fetch({ url: "/send-multiple-invitations/by-closet-admin", method: "post", data });
};
